import React, { Fragment, useCallback } from 'react';
import ScheduleTypeCellParamTemplateContainer from './ScheduleTypeCellParamTemplateContainer';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from 'utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ADMIN_SCHEDULES_READ, ADMIN_SCHEDULES_WRITE } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';
import { usePermission } from 'providers/RightsHooks';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const scheduleTypeCellParamTemplateId = match.params.id && getInt(match.params.id);

  const canWrite = usePermission(ADMIN_SCHEDULES_WRITE);

  const onClickClose = () => {
    historyContext.push('/scheduleTypeCellParamTemplates');
  };

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/scheduleTypeCellParamTemplates/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_SCHEDULES_READ}>
        <ScheduleTypeCellParamTemplateContainer
          scheduleTypeCellParamTemplateId={scheduleTypeCellParamTemplateId}
          onRedirect={onRedirect}
          canWrite={canWrite}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
